import { Tooltip } from 'antd';
import { cn } from '@/libs/utils';
import { truncateWithEllipsis } from '@/utils/utils';

export default function TruncateTooltipCell({
  label,
  className,
  placement = 'topLeft',
  maxLength,
}) {
  const shouldShowTooltip = maxLength && label?.length > maxLength;
  const displayText = maxLength
    ? truncateWithEllipsis(label, maxLength)
    : label;

  return (
    <span
      className={cn(
        'block overflow-hidden text-ellipsis whitespace-nowrap',
        className
      )}
    >
      {shouldShowTooltip ? (
        <Tooltip placement={placement} title={label}>
          <span className="block overflow-hidden text-ellipsis whitespace-nowrap">
            {displayText}
          </span>
        </Tooltip>
      ) : (
        <span className="block overflow-hidden text-ellipsis whitespace-nowrap">
          {displayText}
        </span>
      )}
    </span>
  );
}
